/**
 * Tax Categories - Segmentos y Familias
 * Complete UNSPSC classification system
 * Data imported from GoodsAndServices.json
 */

import GoodsAndServicesData from './GoodsAndServices.json';

export interface Segment {
  Code: number;
  Description: string;
  Status: boolean;
}

export interface Family {
  Segmento: string;
  Code: string;
  Description: string;
}

// Import segments from JSON
export const SEGMENTS: Segment[] = GoodsAndServicesData.Segmento;

// Import families from JSON
const ALL_FAMILIES: Family[] = GoodsAndServicesData.Familia;

// Load families asynchronously (kept for backwards compatibility)
export const loadFamilies = async (): Promise<Family[]> => {
  return Promise.resolve(ALL_FAMILIES);
};

// Get families filtered by segment
export function getFamiliesBySegment(segmentCode: string): Family[] {
  return ALL_FAMILIES.filter(f => f.Segmento === segmentCode);
}

/**
 * OTI (Otros Impuestos y Tasas) Categories
 * Códigos para otros impuestos y tasas que se pueden aplicar a facturas
 */
export interface OTICode {
  code: string;
  description: string;
}

export const OTI_CODES: OTICode[] = [
  { code: "01", description: "SUME 911" },
  { code: "02", description: "Tasa Portabilidad Numérica" },
  { code: "03", description: "Impuesto sobre seguro (5%)" },
  { code: "04", description: "ATTT-Impuestos sobre seguro autos (1%)" },
  { code: "05", description: "Tasa Salida Aeropuerto (FZ)" },
  { code: "06", description: "Cargo Incentivo Desarrollo Aeropuerto (F3)" },
  { code: "07", description: "Cargo Seguridad Aeropuerto (AH)" },
  { code: "08", description: "Otros Cargos (XT)" },
  { code: "09", description: "Combustible (YQ)" },
];
